import PropTypes from 'prop-types'

import StringToNode from '../StringToNode'

import './index.scss'

function Fieldset({ legend, text }) {
	return (
		<fieldset className="SOUKIASSIAN-Fieldset">
			<legend className="SOUKIASSIAN-Fieldset-title">{legend}</legend>
			<StringToNode string={text} />
		</fieldset>
	)
}

Fieldset.propTypes = {
	legend: PropTypes.string,
	text: PropTypes.string,
}

Fieldset.defaultProps = {
	legend: '',
	text: '',
}

export default Fieldset
